parentApplicationInformation.classy.controller({
   name: 'parentApplicationInformationController',
   inject: ['$scope', '$rootScope', 'authServiceFactory','SchoolModelService'],
   init: function()
   {
        this.$.school = this.SchoolModelService.get()[0];
        this.$.domain = this.authServiceFactory.getDomain();
   }

});